const BlockView = require('views/block/base-block-view');
import { KeybindingService, keys } from 'services/keybinding-service';
import IconLoadService from 'services/icon-load-service';
import LocaleService from 'services/locale-service';
import DefaultContent from 'data/content';
import 'views/block/advocate-chat/config/widgets.config';

import ChatIframeView from './chat-iframe';

const { Enter, Space } = keys;

const AdvocateChatView = BlockView.extend({
  className: 'advocate-chat',
  regions: {
    iframeRegion: '.advocate-chat-iframe-container'
  },
  initialize: function() {
    BlockView.prototype.initialize.apply(this, arguments);
    this.cid = this.model.get('cid');
    this.completed = true;

    if(this.model.has('icon_prefix') && this.model.has('icon_name')) {
      IconLoadService.applyIcon(this.model.get('icon_name'), this.cid, this.model.get('icon_size'), this.model.get('icon_prefix'));
    }
    this.postMessage = this.postMessage.bind(this);
  },

  load: function() {
    const chatId = `#advocate-chat-${this.cid}`;
    $(chatId).on('click', () => {
      this.openChat();
    });

    $(chatId).on('keydown', e => {
      KeybindingService.with(e).bind([Enter, Space], () => {
        this.$(e.currentTarget).click();
      });
    });
    window.addEventListener('message', this.postMessage, false);
  },
  openChat: function() {
    const skill = this.model.get('skill');
    const iframe_class = this.model.get('iframe_class');
    const language = LocaleService.getLanguage() || 'en';
    const deployKey = this.model.get('keys')[language];
    const data = { skill, deployKey, iframe_class };
    const chatView = new ChatIframeView({ data, region: 'iframeRegion' });
    this.subview('iframe', chatView);
  },

  postMessage: function(event) {
    if (event.data === 'close' && this.subviewsByName.iframe) {
      this.subviewsByName.iframe.dispose();
    }
  },

  play: function() {
    this.readyToGo();
  },
  dispose: function() {
    window.removeEventListener('message', this.postMessage, false);
  }
});

module.exports = AdvocateChatView;
